import React from "react";
import { EditField } from "../types";
import colors from "../../../colors/colors";

interface NumberFieldProps {
  value: number;
  onChange: (value: number) => void;
  field: EditField;
}

export const NumberField: React.FC<NumberFieldProps> = ({
  value,
  onChange,
  field,
}) => {
  return (
    <input
      type="number"
      value={value || 0}
      min={field.min}
      max={field.max}
      step={field.step || 1}
      onChange={(e) => onChange(parseFloat(e.target.value))}
      className="edit-panel-input"
      style={{
        width: "100%",
        padding: "12px 14px",
        border: `1px solid ${colors.border_glass}`,
        borderRadius: "10px",
        fontSize: "13px",
        color: colors.primary,
        boxSizing: "border-box",
        transition: "all 0.15s ease",
        background: colors.white,
        outline: "none",
      }}
    />
  );
};

